"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowStartStatusSchema = exports.WorkflowStartStatus = void 0;
exports.isWorkflowStartStatus = isWorkflowStartStatus;
const z = require("zod");
var WorkflowStartStatus;
(function (WorkflowStartStatus) {
    WorkflowStartStatus["Started"] = "started";
    WorkflowStartStatus["AlreadyRunning"] = "already_running";
    WorkflowStartStatus["AlreadyCompleted"] = "already_completed";
})(WorkflowStartStatus || (exports.WorkflowStartStatus = WorkflowStartStatus = {}));
exports.workflowStartStatusSchema = z.nativeEnum(WorkflowStartStatus);
function isWorkflowStartStatus(value) {
    return Object.values(WorkflowStartStatus).includes(value);
}
//# sourceMappingURL=workflow-start-status.js.map